import React from 'react';
import '../Footer.css'; 
import { FaFacebook, FaInstagram, FaLinkedin, FaTiktok } from 'react-icons/fa'; // Icons from react-icons
import Logo from '../assets/logo.jpg'; 

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-left">
        <ul>
          <li><a href="/nos-realisations">Nos réalisations</a></li>
          <li><a href="/nos-valeurs">Nos valeurs</a></li>
          <li><a href="/nos-metiers">Nos métiers</a></li>
          <li><a href="/#contact">Contact</a></li> {/* Lien vers la section "Contact" avec ancrage */}
        </ul>
      </div>

      <div className="footer-center">
        <img src={Logo} alt="Logo" style={{ width: '140px' }} />
        <p><a href="#">Mentions légales</a></p>
        <p><a href="#">Politique de confidentialité</a></p>
      </div>

      <div className="footer-right">
        <p>Retrouvez-nous sur les réseaux sociaux</p>
        <div className="social-icons">
          <a href="https://www.facebook.com/share/1BaQhZ87B6/" target="_blank" rel="noreferrer"><FaFacebook /></a>
          <a href="https://www.instagram.com/les.voiriesfranciliennes/" target="_blank" rel="noreferrer"><FaInstagram /></a>
          <a href="https://www.linkedin.com/company/les-voiries-franciliennes/" target="_blank" rel="noreferrer"><FaLinkedin /></a>
          <a href="https://www.tiktok.com/@les.voiries.fr" target="_blank" rel="noreferrer"><FaTiktok /></a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
